import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { App } from "../services/Types";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: "3px",
  textAlign: "center",
  height: "100%",
}));

const useStyles = makeStyles({
  grid: {
    height: "220px",
    textDecoration: "none !important",
    "& :hover": {
      cursor: "pointer",
    },
    width: "220px",
  },
  logo: {
    height: "80px",
    marginTop: "38px",
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
  link: {
    textDecoration: "none",
    fontFamily: "Roboto",
    color: "#232323",
    fontSize: "14px",
    height: "100%",
    width: "100%",
    display: "inline-block",
  },
});

const Tile = ({ app }: { app: App }) => {
  const classes = useStyles();
  const imageName = `${app.image || app.id}.png`;
  const backgroundImage = `url(/images/apps/${imageName})`;

  const onclick = (event: any, app: App) => {
    event.preventDefault();
    window.open(app.url, app.id);
  };

  return (
    <Grid className={classes.grid} item>
      <Item>
        <a
          className={classes.link}
          onClick={(event: any) => onclick(event, app)}
          href={app.url}
        >
          <div
            className={classes.logo}
            style={{
              backgroundImage,
            }}
          ></div>
          <div>{app.name}</div>
        </a>
      </Item>
    </Grid>
  );
};

export default Tile;
